<template>
	<div class="content-text">
		<div class="display-flex-center justify-content-between full-width wrap-btns">
			<div class="d-flex content-d-flex conten-text-view">
				<a href="javascript:;" @click="previewDoc(dataSource)">
					Giới thiệu sách
				</a>
				<!-- <a style="margin-left: 10px;" href="javascript:;" @click="directTrainingApp">
					Tài liệu tập huấn 
				</a> -->
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import mixinsFiles from './mixinsFiles'
	import { APP_CONFIG } from '@/utils/constants'
	import { getAuth } from '@/utils/jwt'
	import { EMAIL_PUBLIC } from '@/store/auth/constants'
	import { STORE_KEY as STORE_KEY_BOOK } from '@/modules/ebooks/_store/constants'

	export default {
		name: 'DetailButton',
		mixins: [ mixinsFiles ],
		props: {
			type: String,
			path: String,
			pathView: String,
			name: String,
			dataSource: Object
		},
		computed: {
			...mapGetters({
				ebooksDetail: STORE_KEY_BOOK + '/ebooksDetail',
				getTraningId: STORE_KEY_BOOK + '/getTraningId'
			}),
			authInfo() {
				return getAuth()
			}
		},
		data () {
			return {
				appUrl: APP_CONFIG.appUrl,
				emailPublic: EMAIL_PUBLIC
			}
		},
		beforeDestroy() {
			this.toggleModalPreview(false)
		},
		methods: {
			...mapActions('common', ['toggleModalPreview', 'setDocPreviewContent']),

			previewDoc(data) {
				//console.log('preview: ', data);
				this.setDocPreviewContent({...data, bookInfo: {fileName: data.fileName, totalPage: data.totalPage}});
				this.toggleModalPreview(true)
			},

			/**
			* @ function direct to taphuan
			* id: 83 -> Khoá tập huấn Bộ sách giáo khoa Kết nối tri thức với cuộc sống
			* id: 84 -> Khoá tập huấn Bộ sách giáo khoa Cùng học để phát triển năng lực
			* id: 95 -> Khoá tập huấn Bộ sách giáo khoa Chân trời sáng tạo
			* id: 96 -> Khoá tập huấn Bộ sách giáo khoa Vì sự bình đẳng và dân chủ trong giáo dục
			**/
			directTrainingApp() {
				let bookTypeId = this.ebooksDetail.bookTypeId;
				/**
				* book type id = 3: Kết nối tri thức với cuộc sống
				* book type id = 4: Chân trời sáng tạo
				**/
				let trainingId = this.getTraningId.trainingId;
				window.open(
					// live
					`https://taphuan.nxbgd.vn/giao-vien/tap-huan/${trainingId}?from=hts`,
					'_blank'
					// QA
					// `hhttp://taphuan.niw.com.vn/giao-vien/tap-huan/${trainingId}?from=hts`,
					// '_blank'
				);
			}

		}
	}
</script>

<style lang="scss" scoped>
$cl-xam: #879AA9;
$cl-xanh: #124ABE;
html {scroll-behavior: smooth; }

	.content-text{
		padding-top: 12px;		
		padding-bottom: 12px;
		span{
			cursor: pointer;
			color:#40505e;
			font-size:13px;
		}
		a{
			text-decoration: none;
			background-color: #E1EFFF;
			color:#40505e;
			border-radius: 20px;
			padding: 4px 20px;
			color:$cl-xanh;
			&:hover{
				color:$cl-xanh;
			}
			span{
				font-size:13px;
			}
		}
		a{
			.imgdown{
			height: 15px;
				&:hover{
					color:$cl-xanh;
				}
			}
			&:hover{
				color:$cl-xanh;
			}
		}
	}

</style>